module.exports = __webpack_public_path__ + "img/gplay.7314fb98.png";